import { useEffect, useState } from "react";

/**
 * GLOSS Logomark — 4 diamond/rhombus shapes in a 2x2 grid
 * inside a rounded-square container, gold-gradient fills.
 * Each diamond scales in with 80ms stagger.
 */
export function GlossLogomark({ size = 40, animate = true }) {
  const [mounted, setMounted] = useState(!animate);
  useEffect(() => { if (animate) setMounted(true); }, [animate]);

  const containerStyle = {
    width: size,
    height: size,
    borderRadius: size * 0.22,
    background: "linear-gradient(180deg,#FFF7E4 0%, #FAF0F0 100%)",
    boxShadow:
      `inset 0 1px 0 0 rgba(255,255,255,0.95), inset 0 -1px 0 0 rgba(142,106,26,0.18), 0 6px 14px -4px rgba(142,106,26,0.30)`,
    border: "1px solid rgba(212,168,83,0.45)",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    gap: size * 0.08,
    padding: size * 0.18,
  };

  const diamond = (i) => ({
    width: "100%",
    height: "100%",
    transform: mounted ? "rotate(45deg) scale(1)" : "rotate(45deg) scale(0)",
    transition: `transform 460ms cubic-bezier(0.34,1.56,0.64,1) ${i * 80}ms`,
    background: "linear-gradient(135deg,#F0D898 0%,#E8C98A 25%,#D4A853 60%,#B5892E 100%)",
    borderRadius: 2,
    boxShadow: "inset 0 1px 0 0 rgba(255,255,255,0.65), inset 0 -1px 0 0 rgba(142,106,26,0.45)",
  });

  return (
    <div style={containerStyle} aria-label="GLOSS logo">
      <div style={diamond(0)} />
      <div style={diamond(1)} />
      <div style={diamond(2)} />
      <div style={diamond(3)} />
    </div>
  );
}

export default GlossLogomark;
